import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs1005',
    ecrans: [
        '00-2'
    ]    
});

